import { render, staticRenderFns } from "./contactUsComponent.vue?vue&type=template&id=a04a4576&scoped=true&"
import script from "./contactUsComponent.vue?vue&type=script&lang=js&"
export * from "./contactUsComponent.vue?vue&type=script&lang=js&"
import style0 from "./contactUsComponent.vue?vue&type=style&index=0&id=a04a4576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04a4576",
  null
  
)

export default component.exports